import { useState } from "react";
import { useRouter } from "next/router";
import { useCurrentBrandData } from "utils/currentUserHooks";
import { BRAND_INDEX } from "utils/links";
import { getOnboardingFlowStatus, OnboardingFlowStatus } from "./metadata";
import SetupModal from "./SetupModal";
import SetupWidget from "./SetupWidget";
import useCurrentBrandOnboarding from "./useCurrentBrandOnboarding";

export default function Onboarding() {
  const router = useRouter();
  const brand = useCurrentBrandData();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const status = getOnboardingFlowStatus(brand?.metadata);
  const shouldSuppressHomeOnboarding =
    router.pathname === BRAND_INDEX &&
    status !== OnboardingFlowStatus.COMPLETED;
  const {
    completedCount,
    dismiss,
    isCompleted,
    isVisible,
    shouldShowSetupGuide,
    steps,
  } = useCurrentBrandOnboarding({
    skip: shouldSuppressHomeOnboarding,
  });

  if (!isVisible) return null;

  return (
    <>
      <SetupModal
        completedCount={completedCount}
        isOpen={isModalOpen && shouldShowSetupGuide}
        onClose={() => setIsModalOpen(false)}
        steps={steps}
      />

      {(!isModalOpen || isCompleted) && (
        <SetupWidget
          completedCount={completedCount}
          isCompleted={isCompleted}
          onDismiss={dismiss}
          onOpen={() => setIsModalOpen(true)}
          totalCount={steps.length}
        />
      )}
    </>
  );
}
